import { KnaufPalettes } from './knauf-palettes.enum';
import { Palette } from './palette';


const TopDesign: Palette = {
  name: "Top Design",
  description: "!!!!!!! Paleta kolorów oparta na odcieniach szarości, inspirowana stylem skandynawskim, minimalizmem i najnowszymi trendami w projektowaniu.Doskonale sprawdza się w połączeniu z prostymi bryłami i modernistyczną architekturą, spotykaną w przypadku nowo budowanych domów, częściej w przestrzeni miejskiej.",
  basic: [
    { code: 'C 3442 PG II', rgb: '#B1B4B1' },
    { code: 'C 3490 PG II', rgb: '#C0C8C7' },
    { code: 'C 3482 PG III', rgb: '#A9B0B2' },
    { code: 'C 3483 PG III', rgb: '#C7CCCD' },
    { code: 'C 3501 PG III', rgb: '#A1ADB2' },
    { code: 'C 3502 PG III', rgb: '#C1CDCF' },
    { code: 'C 3521 PG III', rgb: '#A9B9BD' },
    { code: 'C 3522 PG II', rgb: '#B6C7CD' },
    { code: 'C 3531 PG III', rgb: '#A4B7B8' },
    { code: 'C 3532 PG III', rgb: '#C2D1D1' },
    { code: 'C 3331 PG II', rgb: '#C1CFBE' },
    { code: 'C 3332 PG II', rgb: '#CEDBCE' },
    { code: 'C 3492 PG II', rgb: '#CAD2D0' },
    { code: 'C 3512 PG II', rgb: '#D2D5D2' },
    { code: 'C 3491 PG II', rgb: '#C5CCCB' },
    { code: 'C 3523 PG II', rgb: '#CBD8D6' },
    { code: 'C 3524 PG II', rgb: '#D8E3E0' },
    { code: 'C 3244 PG II', rgb: '#E6F0EB' },
    { code: 'C 3223 PG III', rgb: '#E2EBEE' },
    { code: 'C 3484 PG II', rgb: '#E0E6E3' },
    { code: 'C 3503 PG III', rgb: '#E1EAE8' },
    { code: 'C 3233 PG III', rgb: '#E2F1F3' },
    { code: 'C 3264 PG II', rgb: '#EAFAFB' },
    { code: 'C 3543 PG II', rgb: '#E0EBE4' },
    { code: 'C 3224 PG II', rgb: '#F8FDFC' },
    { code: 'C 3444 PG II', rgb: '#E3E6E0' },
    { code: 'C 3494 PG II', rgb: '#E6EAE3' },
    { code: 'C 3504 PG III', rgb: '#F2FAF4' },
    { code: 'C 3534 PG II', rgb: '#F7FDF7' },
    { code: 'C 3274 PG II', rgb: '#F5FDFB' },
  ],
  extended: [
    { code: 'C 3440 PG III', rgb: '#7C7F7C' },
    { code: 'C 3441 PG III', rgb: '#999B95' },
    { code: 'C 3480 PG III', rgb: '#768086' },
    { code: 'C 3481 PG III', rgb: '#8A9195' },
    { code: 'C 3210 PG III', rgb: '#797783' },
    { code: 'C 3190 PG III', rgb: '#7D797D' },
    { code: 'C 3520 PG III', rgb: '#A1B1B7' },
    { code: 'C 3221 PG III', rgb: '#AAB9C4' },
    { code: 'C 3211 PG III', rgb: '#9F9CA6' },
    { code: 'C 3542 PG II', rgb: '#C7D3CE' },
    { code: 'C 3222 PG III', rgb: '#C9D5DB' },
    { code: 'C 3192 PG III', rgb: '#B2AFB1' },
    { code: 'C 3473 PG II', rgb: '#DDE2DC' },
    { code: 'C 3493 PG II', rgb: '#DADFDD' },
    { code: 'C 3193 PG III', rgb: '#CECCCB' },
  ],
  accent: [
    { code: '4830', rgb: '#4A5C54' },
    { code: '4320', rgb: '#00729D' },
    { code: '4850', rgb: '#3C6E82' },
    { code: '4851', rgb: '#3C6E82' },
    { code: '4020', rgb: '#F8CD4C' },
  ],
  proposed: [
    { code: '4830', rgb: '#4A5C54' },
    { code: '4320', rgb: '#00729D' },
    { code: '4850', rgb: '#3C6E82' },
  ],
  background: 'red',
  imgs: [
    'assets/domy/dom1_miejski_szyk.jpg',
    'assets/domy/dom2_miejski_szyk.jpg',
    'assets/domy/dom3_miejski_szyk.jpg',
    'assets/domy/dom4_miejski_szyk.jpg',
  ]
};

const MiejskiSzyk: Palette = {
    name: "Miejski szyk",
    description: "Paleta kolorów oparta na odcieniach szarości, inspirowana stylem skandynawskim, minimalizmem i najnowszymi trendami w projektowaniu.Doskonale sprawdza się w połączeniu z prostymi bryłami i modernistyczną architekturą, spotykaną w przypadku nowo budowanych domów, częściej w przestrzeni miejskiej.",
    basic: [
        { code: 'C 3442 PG II', rgb: '#B1B4B1' },
        { code: 'C 3490 PG II', rgb: '#C0C8C7' },
        { code: 'C 3482 PG III', rgb: '#A9B0B2' },
        { code: 'C 3483 PG III', rgb: '#C7CCCD' },
        { code: 'C 3501 PG III', rgb: '#A1ADB2' },
        { code: 'C 3502 PG III', rgb: '#C1CDCF' },
        { code: 'C 3521 PG III', rgb: '#A9B9BD' },
        { code: 'C 3522 PG II', rgb: '#B6C7CD' },
        { code: 'C 3531 PG III', rgb: '#A4B7B8' },
        { code: 'C 3532 PG III', rgb: '#C2D1D1' },
        { code: 'C 3331 PG II', rgb: '#C1CFBE' },
        { code: 'C 3332 PG II', rgb: '#CEDBCE' },
        { code: 'C 3492 PG II', rgb: '#CAD2D0' },
        { code: 'C 3512 PG II', rgb: '#D2D5D2' },
        { code: 'C 3491 PG II', rgb: '#C5CCCB' },
        { code: 'C 3523 PG II', rgb: '#CBD8D6' },
        { code: 'C 3524 PG II', rgb: '#D8E3E0' },
        { code: 'C 3244 PG II', rgb: '#E6F0EB' },
        { code: 'C 3223 PG III', rgb: '#E2EBEE' },
        { code: 'C 3484 PG II', rgb: '#E0E6E3' },
        { code: 'C 3503 PG III', rgb: '#E1EAE8' },
        { code: 'C 3233 PG III', rgb: '#E2F1F3' },
        { code: 'C 3264 PG II', rgb: '#EAFAFB' },
        { code: 'C 3543 PG II', rgb: '#E0EBE4' },
        { code: 'C 3224 PG II', rgb: '#F8FDFC' },
        { code: 'C 3444 PG II', rgb: '#E3E6E0' },
        { code: 'C 3494 PG II', rgb: '#E6EAE3' },
        { code: 'C 3504 PG III', rgb: '#F2FAF4' },
        { code: 'C 3534 PG II', rgb: '#F7FDF7' },
        { code: 'C 3274 PG II', rgb: '#F5FDFB' },
    ],
    extended: [
        { code: 'C 3440 PG III', rgb: '#7C7F7C' },
        { code: 'C 3441 PG III', rgb: '#999B95' },
        { code: 'C 3480 PG III', rgb: '#768086' },
        { code: 'C 3481 PG III', rgb: '#8A9195' },
        { code: 'C 3210 PG III', rgb: '#797783' },
        { code: 'C 3190 PG III', rgb: '#7D797D' },
        { code: 'C 3520 PG III', rgb: '#A1B1B7' },
        { code: 'C 3221 PG III', rgb: '#AAB9C4' },
        { code: 'C 3211 PG III', rgb: '#9F9CA6' },
        { code: 'C 3542 PG II', rgb: '#C7D3CE' },
        { code: 'C 3222 PG III', rgb: '#C9D5DB' },
        { code: 'C 3192 PG III', rgb: '#B2AFB1' },
        { code: 'C 3473 PG II', rgb: '#DDE2DC' },
        { code: 'C 3493 PG II', rgb: '#DADFDD' },
        { code: 'C 3193 PG III', rgb: '#CECCCB' },
    ],
    accent: [
        { code: '4830', rgb: '#4A5C54' },
        { code: '4320', rgb: '#00729D' },
        { code: '4850', rgb: '#3C6E82' },
        { code: '4851', rgb: '#3C6E82' },
        { code: '4020', rgb: '#F8CD4C' },
    ],
    proposed: [
        { code: '4830', rgb: '#4A5C54' },
        { code: '4320', rgb: '#00729D' },
        { code: '4850', rgb: '#3C6E82' },
    ],
    background: '#c5cccb',
    imgs: [
        'assets/domy/dom1_miejski_szyk.jpg',
        'assets/domy/dom2_miejski_szyk.jpg',
        'assets/domy/dom3_miejski_szyk.jpg',
        'assets/domy/dom4_miejski_szyk.jpg',
    ]
};

const KlasycznaElegancja: Palette = {
    name: "Klasyczna elegancja",
    description: "Paleta ciepłych, stonowanych barw dla osób szukających inspiracji w tradycyjnych projektach architektonicznych. Szlachetne beże i brązy nadadzą nawet nowoczesnym domom klasyczny, elegancki wygląd.",
    basic: [
        { code: 'C 3513 PG II', rgb: '#DCDFDA' },
        { code: 'C 3214 PG II', rgb: '#E7EBEB' },
        { code: 'C 3460 PG II', rgb: '#9A988C' },
        { code: 'C 3461 PG II', rgb: '#A9A99B' },
        { code: 'C 3430 PG III', rgb: '#78726A' },
        { code: 'C 3431 PG II', rgb: '#948D83' },
        { code: 'C 3420 PG II', rgb: '#917E71' },
        { code: 'C 3120 PG III', rgb: '#A5785E' },
        { code: 'C 3151 PG III', rgb: '#B2786D' },
        { code: 'C 3141 PG III', rgb: '#A6725C' },
        { code: 'C 3181 PG III', rgb: '#AB8483' },
        { code: 'C 3171 PG II', rgb: '#C7A599' },
        { code: 'C 3423 PG II', rgb: '#E3DBD1' },
        { code: 'C 3450 PG II', rgb: '#BDB29C' },
        { code: 'C 3432 PG II', rgb: '#ADA79B' },
        { code: 'C 3411 PG II', rgb: '#AB8C74' },
        { code: 'C 3142 PG II', rgb: '#B0775E' },
        { code: 'C 3422 PG II', rgb: '#C7B8AB' },
        { code: 'C 3053 PG II', rgb: '#F8EECE' },
        { code: 'C 3451 PG II', rgb: '#CDC2AD' },
        { code: 'C 3433 PG II', rgb: '#CAC6BA' },
        { code: 'C 3412 PG II', rgb: '#C0A38C' },
        { code: 'C 3122 PG II', rgb: '#D9B399' },
        { code: 'C 3172 PG II', rgb: '#DCC5BA' },
        { code: 'C 3084 PG II', rgb: '#FCFAE8' },
        { code: 'C 3383 PG II', rgb: '#E0DECC' },
        { code: 'C 3452 PG II', rgb: '#DFD6C3' },
        { code: 'C 3413 PG II', rgb: '#D9C2AD' },
        { code: 'C 3104 PG II', rgb: '#FDF2DD' },
        { code: 'C 3164 PG II', rgb: '#EFD6C7' },
    ],
    extended: [
        { code: 'C 3140 PG III', rgb: '#9E3A37' },
        { code: 'C 3121 PG III', rgb: '#C89B7F' },
        { code: 'C 3080 PG II', rgb: '#EDB371' },
        { code: 'C 3081 PG II', rgb: '#F6C68E' },
        { code: 'C 3061 PG II', rgb: '#F9D896' },
        { code: 'C 3062 PG II', rgb: '#FDE5AA' },
        { code: 'C 3132 PG II', rgb: '#D1B19E' },
        { code: 'C 3083 PG II', rgb: '#FCF0D5' },
        { code: 'C 3042 PG II', rgb: '#FCECBC' },
        { code: 'C 3453 PG II', rgb: '#E6E1D3' },
        { code: 'C 3394 PG II', rgb: '#E7E4D5' },
        { code: 'C 3424 PG II', rgb: '#F2EFE6' },
        { code: 'C 3463 PG II', rgb: '#DDE0D6' },
        { code: 'C 3514 PG II', rgb: '#ECEEE5' },
        { code: 'C 3474 PG II', rgb: '#F0F4EC' },
    ],
    accent: [
        { code: '4780', rgb: '#8C5047' },
        { code: '4620', rgb: '#975941' },
        { code: '4110', rgb: '#944C31' },
        { code: '4120', rgb: '#A0392B' },
        { code: '4150', rgb: '#9E3A37' },
    ],
    proposed: [
        { code: '4110', rgb: '#944C31' },
        { code: '4120', rgb: '#A0392B' },
        { code: '4150', rgb: '#9E3A37' },
    ],
    background: '#a98c76',
    imgs: [
        'assets/domy/dom1_klasyczna_elegancja.jpg',
        'assets/domy/dom2_klasyczna_elegancja.jpg',
        'assets/domy/dom3_klasyczna_elegancja.jpg',
        'assets/domy/dom4_klasyczna_elegancja.jpg',
    ]
};

const SwiatoweInspiracje: Palette = {
    name: "Światowe inspiracje",
    description: "Paleta najbardziej różnorodnych kolorów, przywołujących ciepłe i intensywne barwy architektury śródziemnomorskiej. Punkt wyjścia do tworzenia odważnych i bogatych zestawień kolorystycznych na elewacjach budynków, zainspirowanych nowoczesną architekturą światową.",
    basic: [
        { code: 'C 3070 PG III', rgb: '#DEAE64' },
        { code: 'C 3051 PG II', rgb: '#EDCF90' },
        { code: 'C 3111 PG III', rgb: '#D79C6C' },
        { code: 'C 3091 PG II', rgb: '#E3AB6C' },
        { code: 'C 3110 PG III', rgb: '#E3AB6C' },
        { code: 'C 3090 PG III', rgb: '#CA9056' },
        { code: 'C 3180 PG III', rgb: '#926B6C' },
        { code: 'C 3130 PG III', rgb: '#B58B79' },
        { code: 'C 3200 PG III', rgb: '#707482' },
        { code: 'C 3191 PG III', rgb: '#9B9597' },
        { code: 'C 3530 PG III', rgb: '#899E9E' },
        { code: 'C 3541 PG III', rgb: '#A6B7AF' },
        { code: 'C 3052 PG II', rgb: '#F1DBA8' },
        { code: 'C 3072 PG II', rgb: '#F7D292' },
        { code: 'C 3101 PG II', rgb: '#D4A67B' },
        { code: 'C 3152 PG II', rgb: '#C48F87' },
        { code: 'C 3220 PG III', rgb: '#909EAC' },
        { code: 'C 3230 PG III', rgb: '#8DAFC5' },
        { code: 'C 3064 PG II', rgb: '#FEF1CE' },
        { code: 'C 3093 PG II', rgb: '#F8DAAE' },
        { code: 'C 3113 PG II', rgb: '#F2CDA8' },
        { code: 'C 3143 PG II', rgb: '#C78D75' },
        { code: 'C 3510 PG III', rgb: '#B7BEC0' },
        { code: 'C 3240 PG III', rgb: '#B1D1DC' },
        { code: 'C 3074 PG II', rgb: '#E6F8FA' },
        { code: 'C 3054 PG II', rgb: '#F8F3DE' },
        { code: 'C 3414 PG II', rgb: '#EFE5D7' },
        { code: 'C 3123 PG II', rgb: '#E7CDB8' },
        { code: 'C 3511 PG II', rgb: '#BEC3C4' },
        { code: 'C 3254 PG II', rgb: '#E7F7F8' },
    ],
    extended: [
        { code: 'C 3320 PG III', rgb: '#92AA96' },
        { code: 'C 3384 PG II', rgb: '#F7F8EB' },
        { code: 'C 3344 PG II', rgb: '#F6FCF2' },
        { code: 'C 3071 PG II', rgb: '#EEBF76' },
        { code: 'C 3464 PG II', rgb: '#EAE9DD' },
        { code: 'C 3500 PG III', rgb: '#839198' },
        { code: 'C 3100 PG III', rgb: '#B17E53' },
        { code: 'C 3462 PG II', rgb: '#EAE9DD' },
        { code: 'C 3112 PG II', rgb: '#E6B587' },
        { code: 'C 3282 PG III', rgb: '#AFCFD3' },
        { code: 'C 3160 PG II', rgb: '#C08A7C' },
        { code: 'C 3314 PG II', rgb: '#F7FDF2' },
        { code: 'C 3533 PG III', rgb: '#E2EDEA' },
        { code: 'C 3133 PG II', rgb: '#E0C7B3' },
        { code: 'C 3280 PG III', rgb: '#926B6C' },
    ],
    accent: [
        { code: '4840', rgb: '#465959' },
        { code: '4260', rgb: '#40627D' },
        { code: '4100', rgb: '#AF5637' },
        { code: '4050', rgb: '#D29645' },
        { code: '4041', rgb: '#E2B737' },
    ],
    proposed: [
        { code: '4260', rgb: '#40627D' },
        { code: '4100', rgb: '#AF5637' },
        { code: '4050', rgb: '#D29645' },
    ],
    background: '#b3d1db',
    imgs: [
        'assets/domy/dom1_swiatowe_inspiracje.jpg',
        'assets/domy/dom2_swiatowe_inspiracje.jpg',
        'assets/domy/dom3_swiatowe_inspiracje.jpg',
        'assets/domy/dom4_swiatowe_inspiracje.jpg',
    ]
};

const WZgodzieZNatura: Palette = {
    name: "W zgodzie z naturą",
    description: "Paleta łagodnych odcieni zieleni i brązu dla wszystkich miłośników przyrody i spokojnego trybu życia. Barwy, które bardzo dobrze wpisują się w naturalne otoczenie, doskonały wybór dla domu w pobliżu lasu, jeziora czy parku. Sprawdzą się zarówno w budownictwie tradycyjnym, jak i nowoczesnym.",
    basic: [
        { code: 'C 3470 PG III', rgb: '#838984' },
        { code: 'C 3360 PG III', rgb: '#838870' },
        { code: 'C 3340 PG III', rgb: '#95A983' },
        { code: 'C 3380 PG III', rgb: '#968D75' },
        { code: 'C 3390 PG III', rgb: '#7C725C' },
        { code: 'C 3410 PG III', rgb: '#8C6C56' },
        { code: 'C 3471 PG II', rgb: '#A0A7A2' },
        { code: 'C 3361 PG III', rgb: '#A3A88E' },
        { code: 'C 3341 PG II', rgb: '#B3C4A3' },
        { code: 'C 3001 PG II', rgb: '#E7E1B5' },
        { code: 'C 3391 PG II', rgb: '#9F947C' },
        { code: 'C 3392 PG II', rgb: '#BBAF98' },
        { code: 'C 3472 PG II', rgb: '#BEC3BF' },
        { code: 'C 3362 PG II', rgb: '#BEC1AC' },
        { code: 'C 3351 PG II', rgb: '#D9E1C3' },
        { code: 'C 3372 PG II', rgb: '#DFD6B6' },
        { code: 'C 3381 PG II', rgb: '#B4AD93' },
        { code: 'C 3393 PG II', rgb: '#D1CAB6' },
        { code: 'C 3443 PG II', rgb: '#D1D4CE' },
        { code: 'C 3363 PG II', rgb: '#D7DAC9' },
        { code: 'C 3352 PG II', rgb: '#E4EDD5' },
        { code: 'C 3004 PG II', rgb: '#F3F0DA' },
        { code: 'C 3382 PG II', rgb: '#CECAB4' },
        { code: 'C 3454 PG II', rgb: '#EBE6D7' },
        { code: 'C 3304 PG II', rgb: '#F5FEF8' },
        { code: 'C 3333 PG II', rgb: '#D9E3D6' },
        { code: 'C 3353 PG II', rgb: '#E9EDD6' },
        { code: 'C 3374 PG II', rgb: '#FCFDED' },
        { code: 'C 3373 PG II', rgb: '#F6F0D8' },
        { code: 'C 3364 PG II', rgb: '#EBEFE2' },
    ],
    extended: [
        { code: 'C 3401 PG II', rgb: '#AC916B' },
        { code: 'C 3073 PG II', rgb: '#FDE5B4' },
        { code: 'C 3000 PG II', rgb: '#DFD6A6' },
        { code: 'C 3402 PG II', rgb: '#C2A986' },
        { code: 'C 3063 PG II', rgb: '#FCEABF' },
        { code: 'C 3033 PG II', rgb: '#FFF9D1' },
        { code: 'C 3403 PG II', rgb: '#D8C7A8' },
        { code: 'C 3043 PG II', rgb: '#FEF2C6' },
        { code: 'C 3003 PG II', rgb: '#F2EECF' },
        { code: 'C 3094 PG II', rgb: '#FDF1D4' },
        { code: 'C 3044 PG II', rgb: '#FCF4D4' },
        { code: 'C 3034 PG II', rgb: '#FCFDE8' },
        { code: 'C 3404 PG II', rgb: '#EFE8D3' },
        { code: 'C 3434 PG II', rgb: '#E3E3DA' },
        { code: 'C 3354 PG II', rgb: '#F1F2DF' },
    ],
    accent: [
        { code: '4471', rgb: '#639D5F' },
        { code: '4482', rgb: '#BACA75' },
        { code: '4490', rgb: '#B5C14F' },
        { code: '4500', rgb: '#CBC544' },
        { code: '4043', rgb: '#FDDF84' },
    ],
    proposed: [
        { code: '4482', rgb: '#BACA75' },
        { code: '4490', rgb: '#B5C14F' },
        { code: '4500', rgb: '#CBC544' },
    ],
    background: '#b3c3a4',
    imgs: [
        'assets/domy/dom1_w_zgodzie_z_natura.jpg',
        'assets/domy/dom2_w_zgodzie_z_natura.jpg',
        'assets/domy/dom3_w_zgodzie_z_natura.jpg',
        'assets/domy/dom4_w_zgodzie_z_natura.jpg',
    ]
};

const WszystkieKolory: Palette = {
    name: "Wszystkie kolory Knauf",
    description: "Wszystkie kolory Knauf",
    basic: [
        { code: "C 3000 PG II", rgb: "#DFD6A6" },
        { code: "C 3001 PG II", rgb: "#E7E1B5" },
        { code: "C 3002 PG II", rgb: "#EBE7C2" },
        { code: "C 3003 PG II", rgb: "#F2EECF" },
        { code: "C 3004 PG II", rgb: "#F3F0DA" },
        { code: "C 3010 PG III", rgb: "#FDF8B3" },
        { code: "C 3011 PG III", rgb: "#FBFBC1" },
        { code: "C 3012 PG II", rgb: "#FDFDCC" },
        { code: "C 3013 PG II", rgb: "#FCFED7" },
        { code: "C 3014 PG II", rgb: "#FCFEE8" },
        { code: "C 3020 PG III", rgb: "#F3E19A" },
        { code: "C 3021 PG III", rgb: "#F8E8A9" },
        { code: "C 3022 PG II", rgb: "#FAF1BE" },
        { code: "C 3023 PG II", rgb: "#FCFCD7" },
        { code: "C 3024 PG II", rgb: "#FCFFEB" },
        { code: "C 3030 PG III", rgb: "#F6D683" },
        { code: "C 3031 PG III", rgb: "#FCE395" },
        { code: "C 3032 PG II", rgb: "#FDF1BA" },
        { code: "C 3033 PG II", rgb: "#FFF9D1" },
        { code: "C 3034 PG II", rgb: "#FCFDE8" },
        { code: "C 3040 PG III", rgb: "#F8E3AC" },
        { code: "C 3041 PG III", rgb: "#FBE8AF" },
        { code: "C 3042 PG II", rgb: "#FCECBC" },
        { code: "C 3043 PG II", rgb: "#FEF2C6" },
        { code: "C 3044 PG II", rgb: "#FCF4D4" },
        { code: "C 3050 PG II", rgb: "#E1BB71" },
        { code: "C 3051 PG II", rgb: "#EDCF90" },
        { code: "C 3052 PG II", rgb: "#F1DBA8" },
        { code: "C 3053 PG II", rgb: "#F8EECE" },
        { code: "C 3054 PG II", rgb: "#F8F3DE" },
        { code: "C 3060 PG III", rgb: "#F2CC81" },
        { code: "C 3061 PG II", rgb: "#F9D896" },
        { code: "C 3062 PG II", rgb: "#FDE5AA" },
        { code: "C 3063 PG II", rgb: "#FCEABF" },
        { code: "C 3064 PG II", rgb: "#FEF1CE" },
        { code: "C 3070 PG III", rgb: "#DEAE64" },
        { code: "C 3071 PG II", rgb: "#EEBF76" },
        { code: "C 3072 PG II", rgb: "#F7D292" },
        { code: "C 3073 PG II", rgb: "#FDE5B4" },
        { code: "C 3074 PG II", rgb: "#FEF4D6" },
        { code: "C 3080 PG II", rgb: "#EDB371" },
        { code: "C 3081 PG II", rgb: "#F6C68E" },
        { code: "C 3082 PG II", rgb: "#FBDBB0" },
        { code: "C 3083 PG II", rgb: "#FCF0D5" },
        { code: "C 3084 PG II", rgb: "#FCFAE8" },
        { code: "C 3090 PG III", rgb: "#CA9056" },
        { code: "C 3091 PG II", rgb: "#E3AB6C" },
        { code: "C 3092 PG II", rgb: "#EFC189" },
        { code: "C 3093 PG II", rgb: "#F8DAAE" },
        { code: "C 3094 PG II", rgb: "#FDF1D4" },
        { code: "C 3100 PG III", rgb: "#B17E53" },
        { code: "C 3101 PG II", rgb: "#D4A67B" },
        { code: "C 3102 PG II", rgb: "#E6C098" },
        { code: "C 3103 PG II", rgb: "#F2D7B6" },
        { code: "C 3104 PG II", rgb: "#FDF2DD" },
        { code: "C 3110 PG III", rgb: "#B6774D" },
        { code: "C 3111 PG III", rgb: "#D79C6C" },
        { code: "C 3112 PG II", rgb: "#E6B587" },
        { code: "C 3113 PG II", rgb: "#F2CDA8" },
        { code: "C 3114 PG II", rgb: "#FBE9D2" },
        { code: "C 3120 PG III", rgb: "#A5785E" },
        { code: "C 3121 PG III", rgb: "#C89B7F" },
        { code: "C 3122 PG II", rgb: "#D9B399" },
        { code: "C 3123 PG II", rgb: "#E7CDB8" },
        { code: "C 3124 PG II", rgb: "#F8E9D9" },
        { code: "C 3130 PG III", rgb: "#B58B79" },
        { code: "C 3131 PG II", rgb: "#C09780" },
        { code: "C 3132 PG II", rgb: "#D1B19E" },
        { code: "C 3133 PG II", rgb: "#E0C7B3" },
        { code: "C 3140 PG III", rgb: "#F7E1D2" },
        { code: "C 3141 PG III", rgb: "#A6725C" },
        { code: "C 3142 PG II", rgb: "#B0775E" },
        { code: "C 3143 PG II", rgb: "#C78D75" },
        { code: "C 3144 PG II", rgb: "#D9A993" },
        { code: "C 3134 PG II", rgb: "#ECC9B5" },
        { code: "C 3150 PG III", rgb: "#9E6961" },
        { code: "C 3151 PG III", rgb: "#B2786D" },
        { code: "C 3152 PG II", rgb: "#C48F87" },
        { code: "C 3153 PG II", rgb: "#DAB0A7" },
        { code: "C 3154 PG II", rgb: "#EDD4CB" },
        { code: "C 3160 PG II", rgb: "#C08A7C" },
        { code: "C 3161 PG II", rgb: "#D1A697" },
        { code: "C 3162 PG II", rgb: "#D3AEA0" },
        { code: "C 3163 PG II", rgb: "#EACCBF" },
        { code: "C 3164 PG II", rgb: "#EFD6C7" },
        { code: "C 3170 PG II", rgb: "#B59184" },
        { code: "C 3171 PG II", rgb: "#C7A599" },
        { code: "C 3172 PG II", rgb: "#DCC5BA" },
        { code: "C 3173 PG II", rgb: "#E6D7CF" },
        { code: "C 3174 PG II", rgb: "#EBDFD6" },
        { code: "C 3180 PG III", rgb: "#926B6C" },
        { code: "C 3181 PG III", rgb: "#AB8483" },
        { code: "C 3182 PG III", rgb: "#C4A3A3" },
        { code: "C 3183 PG II", rgb: "#D8C3C2" },
        { code: "C 3184 PG II", rgb: "#EFE3DF" },
        { code: "C 3190 PG III", rgb: "#7D797D" },
        { code: "C 3191 PG III", rgb: "#9B9597" },
        { code: "C 3192 PG III", rgb: "#B2AFB1" },
        { code: "C 3193 PG III", rgb: "#CECCCB" },
        { code: "C 3194 PG II", rgb: "#E4E4E2" },
        { code: "C 3200 PG III", rgb: "#707482" },
        { code: "C 3201 PG III", rgb: "#969CA9" },
        { code: "C 3202 PG III", rgb: "#AFB5BE" },
        { code: "C 3203 PG III", rgb: "#C9CFD4" },
        { code: "C 3204 PG II", rgb: "#E2E8E9" },
        { code: "C 3210 PG III", rgb: "#797783" },
        { code: "C 3211 PG III", rgb: "#9F9CA6" },
        { code: "C 3212 PG III", rgb: "#B5B6BF" },
        { code: "C 3213 PG III", rgb: "#D1D3D8" },
        { code: "C 3214 PG II", rgb: "#E7EBEB" },
        { code: "C 3220 PG III", rgb: "#909EAC" },
        { code: "C 3221 PG III", rgb: "#AAB9C4" },
        { code: "C 3222 PG III", rgb: "#C9D5DB" },
        { code: "C 3223 PG III", rgb: "#E2EBEE" },
        { code: "C 3224 PG II", rgb: "#F8FDFC" },
        { code: "C 3230 PG III", rgb: "#8DAFC5" },
        { code: "C 3231 PG III", rgb: "#ACC8DB" },
        { code: "C 3232 PG III", rgb: "#CAE0E9" },
        { code: "C 3233 PG III", rgb: "#E2F1F3" },
        { code: "C 3234 PG II", rgb: "#F3FCFA" },
        { code: "C 3240 PG III", rgb: "#B1D1DC" },
        { code: "C 3241 PG III", rgb: "#C5DFE4" },
        { code: "C 3242 PG III", rgb: "#D6EAEC" },
        { code: "C 3243 PG II", rgb: "#DEECEA" },
        { code: "C 3244 PG II", rgb: "#E6F0EB" },
        { code: "C 3250 PG III", rgb: "#6A9CB2" },
        { code: "C 3251 PG III", rgb: "#96C0D3" },
        { code: "C 3252 PG III", rgb: "#B1D3E1" },
        { code: "C 3253 PG III", rgb: "#D0E9F0" },
        { code: "C 3254 PG II", rgb: "#E7F7F8" },
        { code: "C 3260 PG III", rgb: "#66AABF" },
        { code: "C 3261 PG III", rgb: "#94CDE1" },
        { code: "C 3262 PG III", rgb: "#B0D9E6" },
        { code: "C 3263 PG III", rgb: "#CDEAF3" },
        { code: "C 3264 PG II", rgb: "#EAFAFB" },
        { code: "C 3270 PG III", rgb: "#94CCD2" },
        { code: "C 3271 PG III", rgb: "#ABD8DD" },
        { code: "C 3272 PG III", rgb: "#CDECEF" },
        { code: "C 3273 PG III", rgb: "#E6F8FA" },
        { code: "C 3274 PG II", rgb: "#F5FDFB" },
        { code: "C 3280 PG III", rgb: "#668C93" },
        { code: "C 3281 PG III", rgb: "#93B7BB" },
        { code: "C 3282 PG III", rgb: "#AFCFD3" },
        { code: "C 3283 PG III", rgb: "#CBE3E3" },
        { code: "C 3284 PG II", rgb: "#E3F4F2" },
        { code: "C 3290 PG III", rgb: "#89AFAC" },
        { code: "C 3291 PG III", rgb: "#ADCAC7" },
        { code: "C 3292 PG III", rgb: "#C7DFDB" },
        { code: "C 3293 PG III", rgb: "#DFF0EC" },
        { code: "C 3294 PG II", rgb: "#F7FDF8" },
        { code: "C 3300 PG III", rgb: "#93C9BB" },
        { code: "C 3301 PG III", rgb: "#AFDBD0" },
        { code: "C 3302 PG III", rgb: "#CCEAE1" },
        { code: "C 3303 PG II", rgb: "#EBFCF6" },
        { code: "C 3304 PG II", rgb: "#F5FEF8" },
        { code: "C 3310 PG III", rgb: "#95BBA8" },
        { code: "C 3311 PG III", rgb: "#B2D3C2" },
        { code: "C 3312 PG III", rgb: "#CDE6D8" },
        { code: "C 3313 PG II", rgb: "#E2F4E6" },
        { code: "C 3314 PG II", rgb: "#F7FDF2" },
        { code: "C 3320 PG III", rgb: "#92AA96" },
        { code: "C 3321 PG III", rgb: "#A8BEAB" },
        { code: "C 3322 PG III", rgb: "#C8D9C9" },
        { code: "C 3323 PG II", rgb: "#E1EEE1" },
        { code: "C 3324 PG II", rgb: "#F2FBF1" },
        { code: "C 3330 PG III", rgb: "#BCC6B3" },
        { code: "C 3331 PG II", rgb: "#C1CFBE" },
        { code: "C 3332 PG II", rgb: "#CEDBCE" },
        { code: "C 3333 PG II", rgb: "#D9E3D6" },
        { code: "C 3334 PG II", rgb: "#E8EFE3" },
        { code: "C 3340 PG III", rgb: "#95A983" },
        { code: "C 3341 PG II", rgb: "#B3C4A3" },
        { code: "C 3342 PG II", rgb: "#CFDBC2" },
        { code: "C 3343 PG II", rgb: "#E5F0E1" },
        { code: "C 3344 PG II", rgb: "#F6FCF2" },
        { code: "C 3350 PG II", rgb: "#CFD7B3" },
        { code: "C 3351 PG II", rgb: "#D9E1C3" },
        { code: "C 3352 PG II", rgb: "#E4EDD5" },
        { code: "C 3353 PG II", rgb: "#E9EDD6" },
        { code: "C 3354 PG II", rgb: "#F1F2DF" },
        { code: "C 3360 PG III", rgb: "#838870" },
        { code: "C 3361 PG III", rgb: "#A3A88E" },
        { code: "C 3362 PG II", rgb: "#BEC1AC" },
        { code: "C 3363 PG II", rgb: "#D7DAC9" },
        { code: "C 3364 PG II", rgb: "#EBEFE2" },
        { code: "C 3370 PG III", rgb: "#B09F74" },
        { code: "C 3371 PG II", rgb: "#C6B790" },
        { code: "C 3372 PG II", rgb: "#DFD6B6" },
        { code: "C 3373 PG II", rgb: "#F6F0D8" },
        { code: "C 3374 PG II", rgb: "#FCFDED" },
        { code: "C 3380 PG III", rgb: "#968D75" },
        { code: "C 3381 PG II", rgb: "#B4AD93" },
        { code: "C 3382 PG II", rgb: "#CECAB4" },
        { code: "C 3383 PG II", rgb: "#E0DECC" },
        { code: "C 3384 PG II", rgb: "#F7F8EB" },
        { code: "C 3390 PG III", rgb: "#7C725C" },
        { code: "C 3391 PG II", rgb: "#9F947C" },
        { code: "C 3392 PG II", rgb: "#BBAF98" },
        { code: "C 3393 PG II", rgb: "#D1CAB6" },
        { code: "C 3394 PG II", rgb: "#E7E4D5" },
        { code: "C 3400 PG III", rgb: "#8C7454" },
        { code: "C 3401 PG II", rgb: "#AC916B" },
        { code: "C 3402 PG II", rgb: "#C2A986" },
        { code: "C 3403 PG II", rgb: "#D8C7A8" },
        { code: "C 3404 PG II", rgb: "#EFE8D3" },
        { code: "C 3410 PG III", rgb: "#8C6C56" },
        { code: "C 3411 PG II", rgb: "#AB8C74" },
        { code: "C 3412 PG II", rgb: "#C0A38C" },
        { code: "C 3413 PG II", rgb: "#D9C2AD" },
        { code: "C 3414 PG II", rgb: "#EFE5D7" },
        { code: "C 3420 PG II", rgb: "#917E71" },
        { code: "C 3421 PG II", rgb: "#AA988A" },
        { code: "C 3422 PG II", rgb: "#C7B8AB" },
        { code: "C 3423 PG II", rgb: "#E3DBD1" },
        { code: "C 3424 PG II", rgb: "#F2EFE6" },
        { code: "C 3430 PG III", rgb: "#78726A" },
        { code: "C 3431 PG II", rgb: "#948D83" },
        { code: "C 3432 PG II", rgb: "#ADA79B" },
        { code: "C 3433 PG II", rgb: "#CAC6BA" },
        { code: "C 3434 PG II", rgb: "#E3E3DA" },
        { code: "C 3440 PG III", rgb: "#7C7F7C" },
        { code: "C 3441 PG III", rgb: "#999B95" },
        { code: "C 3442 PG II", rgb: "#B1B4B1" },
        { code: "C 3443 PG II", rgb: "#D1D4CE" },
        { code: "C 3444 PG II", rgb: "#E3E6E0" },
        { code: "C 3450 PG II", rgb: "#BDB29C" },
        { code: "C 3451 PG II", rgb: "#CDC2AD" },
        { code: "C 3452 PG II", rgb: "#DFD6C3" },
        { code: "C 3453 PG II", rgb: "#E6E1D3" },
        { code: "C 3454 PG II", rgb: "#EBE6D7" },
        { code: "C 3460 PG II", rgb: "#9A988C" },
        { code: "C 3461 PG II", rgb: "#A9A99B" },
        { code: "C 3462 PG II", rgb: "#CACBBE" },
        { code: "C 3463 PG II", rgb: "#DDE0D6" },
        { code: "C 3464 PG II", rgb: "#EAE9DD" },
        { code: "C 3470 PG III", rgb: "#838984" },
        { code: "C 3471 PG II", rgb: "#A0A7A2" },
        { code: "C 3472 PG II", rgb: "#BEC3BF" },
        { code: "C 3473 PG II", rgb: "#DDE2DC" },
        { code: "C 3474 PG II", rgb: "#F0F4EC" },
        { code: "C 3480 PG III", rgb: "#768086" },
        { code: "C 3481 PG III", rgb: "#8A9195" },
        { code: "C 3482 PG III", rgb: "#A9B0B2" },
        { code: "C 3483 PG III", rgb: "#C7CCCD" },
        { code: "C 3484 PG II", rgb: "#E0E6E3" },
        { code: "C 3490 PG II", rgb: "#C0C8C7" },
        { code: "C 3491 PG II", rgb: "#C5CCCB" },
        { code: "C 3492 PG II", rgb: "#CAD2D0" },
        { code: "C 3493 PG II", rgb: "#DADFDD" },
        { code: "C 3494 PG II", rgb: "#E6EAE3" },
        { code: "C 3500 PG III", rgb: "#839198" },
        { code: "C 3501 PG III", rgb: "#A1ADB2" },
        { code: "C 3502 PG III", rgb: "#C1CDCF" },
        { code: "C 3503 PG III", rgb: "#E1EAE8" },
        { code: "C 3504 PG III", rgb: "#F2FAF4" },
        { code: "C 3510 PG III", rgb: "#B7BEC0" },
        { code: "C 3511 PG II", rgb: "#BEC3C4" },
        { code: "C 3512 PG II", rgb: "#D2D5D2" },
        { code: "C 3513 PG II", rgb: "#DCDFDA" },
        { code: "C 3514 PG II", rgb: "#ECEEE5" },
        { code: "C 3520 PG III", rgb: "#A1B1B7" },
        { code: "C 3521 PG III", rgb: "#A9B9BD" },
        { code: "C 3522 PG II", rgb: "#B6C7CD" },
        { code: "C 3523 PG II", rgb: "#CBD8D6" },
        { code: "C 3524 PG II", rgb: "#D8E3E0" },
        { code: "C 3530 PG III", rgb: "#899E9E" },
        { code: "C 3531 PG III", rgb: "#A4B7B8" },
        { code: "C 3532 PG III", rgb: "#C2D1D1" },
        { code: "C 3533 PG III", rgb: "#E2EDEA" },
        { code: "C 3534 PG II", rgb: "#F7FDF7" },
        { code: "C 3540 PG III", rgb: "#8B9E97" },
        { code: "C 3541 PG III", rgb: "#A6B7AF" },
        { code: "C 3542 PG II", rgb: "#C7D3CE" },
        { code: "C 3543 PG II", rgb: "#E0EBE4" },
        { code: "C 3544 PG II", rgb: "#F5FCF4" },
        { code: "4000", rgb: "#EDD127" },
        { code: "4001", rgb: "#F8E245" },
        { code: "4002", rgb: "#FFF069" },
        { code: "4003", rgb: "#FFF587" },
        { code: "4004", rgb: "#FEFAAF" },
        { code: "4005", rgb: "#FAFBD3" },
        { code: "4010", rgb: "#FACE0" },
        { code: "4011", rgb: "#FAD2E" },
        { code: "4012", rgb: "#FFDE3F" },
        { code: "4013", rgb: "#FFE767" },
        { code: "4014", rgb: "#FFF294" },
        { code: "4015", rgb: "#FFFABD" },
        { code: "4020", rgb: "#F8CD4C" },
        { code: "4021", rgb: "#F6D964" },
        { code: "4022", rgb: "#FFE474" },
        { code: "4023", rgb: "#FFEE91" },
        { code: "4024", rgb: "#FFF8B4" },
        { code: "4025", rgb: "#FCFDD6" },
        { code: "4030", rgb: "#EFB826" },
        { code: "4031", rgb: "#F9D264" },
        { code: "4032", rgb: "#FFE186" },
        { code: "4033", rgb: "#FFEBA3" },
        { code: "4034", rgb: "#FFF5C4" },
        { code: "4035", rgb: "#FDFADD" },
        { code: "4040", rgb: "#CC9A15" },
        { code: "4041", rgb: "#E2B737" },
        { code: "4042", rgb: "#FAD467" },
        { code: "4043", rgb: "#FDDF84" },
        { code: "4044", rgb: "#FFEEA6" },
        { code: "4045", rgb: "#FEF2C4" },
        { code: "4050", rgb: "#D29645" },
        { code: "4051", rgb: "#E5B264" },
        { code: "4052", rgb: "#F7C77A" },
        { code: "4053", rgb: "#FBD897" },
        { code: "4054", rgb: "#FFEBBA" },
        { code: "4055", rgb: "#FFF5D7" },
        { code: "4060", rgb: "#E5942B" },
        { code: "4061", rgb: "#F1B451" },
        { code: "4062", rgb: "#F9C46F" },
        { code: "4063", rgb: "#FBD78E" },
        { code: "4064", rgb: "#FCE6B0" },
        { code: "4065", rgb: "#FBF3D2" },
        { code: "4070", rgb: "#CD6F28" },
        { code: "4071", rgb: "#E29557" },
        { code: "4072", rgb: "#F4B374" },
        { code: "4073", rgb: "#FACB93" },
        { code: "4074", rgb: "#FDE2B7" },
        { code: "4075", rgb: "#FDF4D7" },
        { code: "4080", rgb: "#D36E36" },
        { code: "4081", rgb: "#E38D59" },
        { code: "4082", rgb: "#EDA570" },
        { code: "4083", rgb: "#F1B88D" },
        { code: "4084", rgb: "#FAD6B1" },
        { code: "4085", rgb: "#FDE7D2" },
        { code: "4090", rgb: "#CD6238" },
        { code: "4091", rgb: "#E1885E" },
        { code: "4092", rgb: "#F2A27B" },
        { code: "4093", rgb: "#F8BD9B" },
        { code: "4094", rgb: "#FAD6B9" },
        { code: "4095", rgb: "#FAEBD9" },
        { code: "4100", rgb: "#AF5637" },
        { code: "4101", rgb: "#CF7350" },
        { code: "4102", rgb: "#E59270" },
        { code: "4103", rgb: "#EAAB8C" },
        { code: "4104", rgb: "#F7C9AE" },
        { code: "4105", rgb: "#F9E3D0" },
        { code: "4110", rgb: "#944C31" },
        { code: "4111", rgb: "#BB6C4E" },
        { code: "4112", rgb: "#D78D6D" },
        { code: "4113", rgb: "#E7A88A" },
        { code: "4114", rgb: "#F4C6AB" },
        { code: "4115", rgb: "#FAE2CF" },
        { code: "4120", rgb: "#A0392B" },
        { code: "4121", rgb: "#BC5147" },
        { code: "4122", rgb: "#D9746C" },
        { code: "4123", rgb: "#E78F87" },
        { code: "4124", rgb: "#EFB4AE" },
        { code: "4125", rgb: "#F8D8D4" },
        { code: "4130", rgb: "#964D4B" },
        { code: "4131", rgb: "#B77473" },
        { code: "4132", rgb: "#D08E90" },
        { code: "4133", rgb: "#DAAAAB" },
        { code: "4134", rgb: "#ECC9C9" },
        { code: "4135", rgb: "#F8E6DF" },
        { code: "4140", rgb: "#B04E4F" },
        { code: "4141", rgb: "#C57076" },
        { code: "4142", rgb: "#D78B93" },
        { code: "4143", rgb: "#E6A4AA" },
        { code: "4144", rgb: "#F2C5CA" },
        { code: "4145", rgb: "#FAE6E5" },
        { code: "4150", rgb: "#9E3A37" },
        { code: "4151", rgb: "#B94B55" },
        { code: "4152", rgb: "#D76C7C" },
        { code: "4153", rgb: "#E28796" },
        { code: "4154", rgb: "#F0ACB9" },
        { code: "4155", rgb: "#F8D1D8" },
        { code: "4160", rgb: "#7F3026" },
        { code: "4161", rgb: "#A74B53" },
        { code: "4162", rgb: "#C26573" },
        { code: "4163", rgb: "#D48494" },
        { code: "4164", rgb: "#E7A8B4" },
        { code: "4165", rgb: "#F1CAD1" },
        { code: "4170", rgb: "#6F3731" },
        { code: "4171", rgb: "#934B57" },
        { code: "4172", rgb: "#B06A7B" },
        { code: "4173", rgb: "#CA8496" },
        { code: "4174", rgb: "#DCA7B7" },
        { code: "4175", rgb: "#E9D0D8" },
        { code: "4180", rgb: "#8C4854" },
        { code: "4181", rgb: "#AD6B7C" },
        { code: "4182", rgb: "#C8889A" },
        { code: "4183", rgb: "#D6A4B3" },
        { code: "4184", rgb: "#E6C6D1" },
        { code: "4185", rgb: "#F5E3E8" },
        { code: "4190", rgb: "#804B59" },
        { code: "4191", rgb: "#9C687C" },
        { code: "4192", rgb: "#B57F94" },
        { code: "4193", rgb: "#C89BAC" },
        { code: "4194", rgb: "#DCBAC9" },
        { code: "4195", rgb: "#ECD9E1" },
        { code: "4200", rgb: "#6E4755" },
        { code: "4201", rgb: "#8F6277" },
        { code: "4202", rgb: "#AB8297" },
        { code: "4203", rgb: "#C29EB1" },
        { code: "4204", rgb: "#D5BCCA" },
        { code: "4205", rgb: "#EADDE5" },
        { code: "4210", rgb: "#645065" },
        { code: "4211", rgb: "#88748E" },
        { code: "4212", rgb: "#A48FA9" },
        { code: "4213", rgb: "#BCAABF" },
        { code: "4214", rgb: "#D5CAD8" },
        { code: "4215", rgb: "#E7E6EB" },
        { code: "4220", rgb: "#635870" },
        { code: "4221", rgb: "#827692" },
        { code: "4222", rgb: "#9F95AE" },
        { code: "4223", rgb: "#BAB0C3" },
        { code: "4224", rgb: "#D1CAD8" },
        { code: "4225", rgb: "#E9E5E9" },
        { code: "4230", rgb: "#526082" },
        { code: "4231", rgb: "#7788A8" },
        { code: "4232", rgb: "#99A8C7" },
        { code: "4233", rgb: "#B1C0D8" },
        { code: "4234", rgb: "#CCD7E7" },
        { code: "4235", rgb: "#E3EEF3" },
        { code: "4240", rgb: "#4D709C" },
        { code: "4241", rgb: "#7598BE" },
        { code: "4242", rgb: "#98B6D7" },
        { code: "4243", rgb: "#B3CFE8" },
        { code: "4244", rgb: "#CCE3F2" },
        { code: "4245", rgb: "#E7F7F9" },
        { code: "4250", rgb: "#496989" },
        { code: "4251", rgb: "#728EAB" },
        { code: "4252", rgb: "#8DA8C5" },
        { code: "4253", rgb: "#A6BDD4" },
        { code: "4254", rgb: "#C6D8E6" },
        { code: "4255", rgb: "#E1EFF4" },
        { code: "4260", rgb: "#40627D" },
        { code: "4261", rgb: "#678DA9" },
        { code: "4262", rgb: "#92B1C6" },
        { code: "4263", rgb: "#ADC7D9" },
        { code: "4264", rgb: "#C8DDE5" },
        { code: "4265", rgb: "#E1EFF1" },
        { code: "4270", rgb: "#4477A4" },
        { code: "4271", rgb: "#70A1C5" },
        { code: "4272", rgb: "#96C0DF" },
        { code: "4273", rgb: "#B1D2E9" },
        { code: "4274", rgb: "#CDE5F1" },
        { code: "4275", rgb: "#E7F4F6" },
        { code: "4280", rgb: "#1E5E93" },
        { code: "4281", rgb: "#5A99CA" },
        { code: "4282", rgb: "#87BBE2" },
        { code: "4283", rgb: "#A6D2EF" },
        { code: "4284", rgb: "#C7E6F7" },
        { code: "4285", rgb: "#E1F2F6" },
        { code: "4290", rgb: "#3488BE" },
        { code: "4291", rgb: "#67ACD6" },
        { code: "4292", rgb: "#93CCF1" },
        { code: "4293", rgb: "#ACD8F2" },
        { code: "4294", rgb: "#C6E7F6" },
        { code: "4295", rgb: "#DFF5F8" },
        { code: "4300", rgb: "#1277AF" },
        { code: "4301", rgb: "#459CCC" },
        { code: "4302", rgb: "#72BEE7" },
        { code: "4303", rgb: "#90CEF0" },
        { code: "4304", rgb: "#B6E0F4" },
        { code: "4305", rgb: "#D4EFF6" },
        { code: "4310", rgb: "#327FA5" },
        { code: "4311", rgb: "#52A0C5" },
        { code: "4312", rgb: "#64B3D8" },
        { code: "4313", rgb: "#86C5E2" },
        { code: "4314", rgb: "#AFDDEC" },
        { code: "4315", rgb: "#D2EFF6" },
        { code: "4320", rgb: "#0729D" },
        { code: "4321", rgb: "#3B9AC2" },
        { code: "4322", rgb: "#4DADD6" },
        { code: "4323", rgb: "#70C0E2" },
        { code: "4324", rgb: "#9BD3EB" },
        { code: "4325", rgb: "#C4E9F5" },
        { code: "4330", rgb: "#136596" },
        { code: "4331", rgb: "#1F84B8" },
        { code: "4332", rgb: "#289BD1" },
        { code: "4333", rgb: "#53B4E1" },
        { code: "4334", rgb: "#89CDEE" },
        { code: "4335", rgb: "#B8E4F2" },
        { code: "4340", rgb: "#155666" },
        { code: "4341", rgb: "#147793" },
        { code: "4342", rgb: "#1E95B9" },
        { code: "4343", rgb: "#45ACCC" },
        { code: "4344", rgb: "#7DC7E2" },
        { code: "4345", rgb: "#ABDFF0" },
        { code: "4350", rgb: "#35879D" },
        { code: "4351", rgb: "#6FAEC3" },
        { code: "4352", rgb: "#97CCDE" },
        { code: "4353", rgb: "#B0D8E5" },
        { code: "4354", rgb: "#CDE9F2" },
        { code: "4355", rgb: "#E8F8F8" },
        { code: "4360", rgb: "#07388" },
        { code: "4361", rgb: "#3799AF" },
        { code: "4362", rgb: "#55B1CC" },
        { code: "4363", rgb: "#7AC7DF" },
        { code: "4364", rgb: "#A6DDEB" },
        { code: "4365", rgb: "#D1F0F6" },
        { code: "4370", rgb: "#137884" },
        { code: "4371", rgb: "#3EA0AE" },
        { code: "4372", rgb: "#52B4C7" },
        { code: "4373", rgb: "#78C6D9" },
        { code: "4374", rgb: "#A8E0EB" },
        { code: "4375", rgb: "#D0F1F4" },
        { code: "4380", rgb: "#1E645F" },
        { code: "4381", rgb: "#1B8687" },
        { code: "4382", rgb: "#3AA2AC" },
        { code: "4383", rgb: "#61BAC6" },
        { code: "4384", rgb: "#92D5DD" },
        { code: "4385", rgb: "#C0EAEE" },
        { code: "4390", rgb: "#1B7A79" },
        { code: "4391", rgb: "#6AADAF" },
        { code: "4392", rgb: "#98CED3" },
        { code: "4393", rgb: "#AED8DC" },
        { code: "4394", rgb: "#CEEBEE" },
        { code: "4395", rgb: "#E6F8F9" },
        { code: "4400", rgb: "#3C6264" },
        { code: "4401", rgb: "#6D9397" },
        { code: "4402", rgb: "#90B5B8" },
        { code: "4403", rgb: "#AAC9CE" },
        { code: "4404", rgb: "#C8DFE1" },
        { code: "4405", rgb: "#E4F3EF" },
        { code: "4410", rgb: "#43665E" },
        { code: "4411", rgb: "#648E8B" },
        { code: "4412", rgb: "#8DB0AE" },
        { code: "4413", rgb: "#A9C9C7" },
        { code: "4414", rgb: "#CAE1DD" },
        { code: "4415", rgb: "#E0F0EE" },
        { code: "4420", rgb: "#3A695A" },
        { code: "4421", rgb: "#6E9A91" },
        { code: "4422", rgb: "#97BDB0" },
        { code: "4423", rgb: "#B0D0C8" },
        { code: "4424", rgb: "#D1E5DA" },
        { code: "4425", rgb: "#E9F6EE" },
        { code: "4430", rgb: "#4A644E" },
        { code: "4431", rgb: "#678370" },
        { code: "4432", rgb: "#92AA95" },
        { code: "4433", rgb: "#ABBFAC" },
        { code: "4434", rgb: "#C7D8C8" },
        { code: "4435", rgb: "#E0EDE1" },
        { code: "4440", rgb: "#537454" },
        { code: "4441", rgb: "#769C87" },
        { code: "4442", rgb: "#96BCA8" },
        { code: "4443", rgb: "#B3D1C1" },
        { code: "4444", rgb: "#D2E7D8" },
        { code: "4445", rgb: "#E1F3E6" },
        { code: "4450", rgb: "#1B6F49" },
        { code: "4451", rgb: "#288B65" },
        { code: "4452", rgb: "#4BAA89" },
        { code: "4453", rgb: "#6DBFA1" },
        { code: "4454", rgb: "#9CD9C2" },
        { code: "4455", rgb: "#C8EEDF" },
        { code: "4460", rgb: "#2C7454" },
        { code: "4461", rgb: "#489879" },
        { code: "4462", rgb: "#5FAF9B" },
        { code: "4463", rgb: "#80C5B3" },
        { code: "4464", rgb: "#A6DBCF" },
        { code: "4465", rgb: "#CEF1E7" },
        { code: "4470", rgb: "#4C8640" },
        { code: "4471", rgb: "#639D5F" },
        { code: "4472", rgb: "#87BD7F" },
        { code: "4473", rgb: "#A1CF99" },
        { code: "4474", rgb: "#BDE2B7" },
        { code: "4475", rgb: "#DDF3D7" },
        { code: "4480", rgb: "#608834" },
        { code: "4481", rgb: "#94AA4B" },
        { code: "4482", rgb: "#BACA75" },
        { code: "4483", rgb: "#CEDA94" },
        { code: "4484", rgb: "#E2E9B3" },
        { code: "4485", rgb: "#F2F7D5" },
        { code: "4490", rgb: "#B5C14F" },
        { code: "4491", rgb: "#CCD571" },
        { code: "4492", rgb: "#DDE687" },
        { code: "4493", rgb: "#E8F0A3" },
        { code: "4494", rgb: "#F5FAC4" },
        { code: "4495", rgb: "#F8FDDF" },
        { code: "4500", rgb: "#CBC544" },
        { code: "4501", rgb: "#DAD55D" },
        { code: "4502", rgb: "#EBE87B" },
        { code: "4503", rgb: "#F1F095" },
        { code: "4504", rgb: "#F9FBB8" },
        { code: "4505", rgb: "#FAFDD9" },
        { code: "4510", rgb: "#5E754D" },
        { code: "4511", rgb: "#7A906C" },
        { code: "4512", rgb: "#96A883" },
        { code: "4513", rgb: "#B2C3A3" },
        { code: "4514", rgb: "#CCD9C0" },
        { code: "4515", rgb: "#E9F1DC" },
        { code: "4520", rgb: "#606749" },
        { code: "4521", rgb: "#828766" },
        { code: "4522", rgb: "#9EA17F" },
        { code: "4523", rgb: "#B3B798" },
        { code: "4524", rgb: "#D0D3BA" },
        { code: "4525", rgb: "#E6EADA" },
        { code: "4530", rgb: "#60654F" },
        { code: "4531", rgb: "#848972" },
        { code: "4532", rgb: "#A2A890" },
        { code: "4533", rgb: "#B9BCA8" },
        { code: "4534", rgb: "#D2D6C6" },
        { code: "4535", rgb: "#E8ECE0" },
        { code: "4540", rgb: "#CD9649" },
        { code: "4541", rgb: "#E2AF66" },
        { code: "4542", rgb: "#EFC077" },
        { code: "4543", rgb: "#F8D393" },
        { code: "4544", rgb: "#FBE7B7" },
        { code: "4545", rgb: "#FBF5DA" },
        { code: "4550", rgb: "#B4793A" },
        { code: "4551", rgb: "#CA925A" },
        { code: "4552", rgb: "#DFA86B" },
        { code: "4553", rgb: "#EEC089" },
        { code: "4554", rgb: "#F7D8AD" },
        { code: "4555", rgb: "#FBEED2" },
        { code: "4560", rgb: "#BC7935" },
        { code: "4561", rgb: "#D99B58" },
        { code: "4562", rgb: "#EAB273" },
        { code: "4563", rgb: "#F5C791" },
        { code: "4564", rgb: "#FADDB5" },
        { code: "4565", rgb: "#FCF2D8" },
        { code: "4570", rgb: "#B76835" },
        { code: "4571", rgb: "#D4844C" },
        { code: "4572", rgb: "#EDA873" },
        { code: "4573", rgb: "#F8C091" },
        { code: "4574", rgb: "#FCDBB3" },
        { code: "4575", rgb: "#FCEDD3" },
        { code: "4580", rgb: "#9B5D34" },
        { code: "4581", rgb: "#B97B50" },
        { code: "4582", rgb: "#D49A6C" },
        { code: "4583", rgb: "#E5B387" },
        { code: "4584", rgb: "#F5CEAA" },
        { code: "4585", rgb: "#FBE9D2" },
        { code: "4590", rgb: "#98633C" },
        { code: "4591", rgb: "#B9855A" },
        { code: "4592", rgb: "#D3A77C" },
        { code: "4593", rgb: "#E7C096" },
        { code: "4594", rgb: "#F0D6B6" },
        { code: "4595", rgb: "#FCF1DC" },
        { code: "4600", rgb: "#7F5633" },
        { code: "4601", rgb: "#A87E57" },
        { code: "4602", rgb: "#CCA47D" },
        { code: "4603", rgb: "#D8B998" },
        { code: "4604", rgb: "#EAD3B8" },
        { code: "4605", rgb: "#F9EEDC" },
        { code: "4610", rgb: "#72533F" },
        { code: "4611", rgb: "#90705A" },
        { code: "4612", rgb: "#AD8E76" },
        { code: "4613", rgb: "#C4A68E" },
        { code: "4614", rgb: "#D6C2AF" },
        { code: "4615", rgb: "#EFE4D7" },
        { code: "4620", rgb: "#975941" },
        { code: "4621", rgb: "#AF7A62" },
        { code: "4622", rgb: "#C48B75" },
        { code: "4623", rgb: "#D6A78E" },
        { code: "4624", rgb: "#E8C8B4" },
        { code: "4625", rgb: "#F5E1D2" },
        { code: "4630", rgb: "#8F5E41" },
        { code: "4631", rgb: "#AA7C62" },
        { code: "4632", rgb: "#C79B80" },
        { code: "4633", rgb: "#D8B39B" },
        { code: "4634", rgb: "#E6CDB8" },
        { code: "4635", rgb: "#F8E8D8" },
        { code: "4640", rgb: "#674232" },
        { code: "4641", rgb: "#775141" },
        { code: "4642", rgb: "#9A715F" },
        { code: "4643", rgb: "#B58C79" },
        { code: "4644", rgb: "#D1B19F" },
        { code: "4645", rgb: "#ECD6C9" },
        { code: "4650", rgb: "#56463C" },
        { code: "4651", rgb: "#927F73" },
        { code: "4652", rgb: "#A99A8D" },
        { code: "4653", rgb: "#C9BCB0" },
        { code: "4654", rgb: "#E3DCD3" },
        { code: "4655", rgb: "#F1EEE4" },
        { code: "4660", rgb: "#916E3F" },
        { code: "4661", rgb: "#B08E60" },
        { code: "4662", rgb: "#CEAF7F" },
        { code: "4663", rgb: "#DEC497" },
        { code: "4664", rgb: "#F3E1C1" },
        { code: "4665", rgb: "#FBF3DC" },
        { code: "4670", rgb: "#735C3B" },
        { code: "4671", rgb: "#927957" },
        { code: "4672", rgb: "#B0946E" },
        { code: "4673", rgb: "#C5AD89" },
        { code: "4674", rgb: "#DCCAAE" },
        { code: "4675", rgb: "#EEE7D3" },
        { code: "4680", rgb: "#5E5945" },
        { code: "4681", rgb: "#77725B" },
        { code: "4682", rgb: "#999077" },
        { code: "4683", rgb: "#B2AB92" },
        { code: "4684", rgb: "#CCC9B4" },
        { code: "4685", rgb: "#E7E6D6" },
        { code: "4690", rgb: "#5C533F" },
        { code: "4691", rgb: "#7E745E" },
        { code: "4692", rgb: "#9E947E" },
        { code: "4693", rgb: "#B9AF97" },
        { code: "4694", rgb: "#CEC8B5" },
        { code: "4695", rgb: "#EBE8DA" },
        { code: "4700", rgb: "#5A554C" },
        { code: "4701", rgb: "#7E7870" },
        { code: "4702", rgb: "#989287" },
        { code: "4703", rgb: "#B0AA9E" },
        { code: "4704", rgb: "#CBC7BC" },
        { code: "4705", rgb: "#E3E3DA" },
        { code: "4710", rgb: "#828582" },
        { code: "4711", rgb: "#9A9C97" },
        { code: "4712", rgb: "#AEB4B3" },
        { code: "4713", rgb: "#CFD4D0" },
        { code: "4714", rgb: "#E0E5E0" },
        { code: "4715", rgb: "#E6EAE4" },
        { code: "4720", rgb: "#48504A" },
        { code: "4721", rgb: "#676F6B" },
        { code: "4722", rgb: "#868C88" },
        { code: "4723", rgb: "#A1A8A3" },
        { code: "4724", rgb: "#C0C5C1" },
        { code: "4725", rgb: "#DEE3DE" },
        { code: "4730", rgb: "#52525E" },
        { code: "4731", rgb: "#797E8D" },
        { code: "4732", rgb: "#969CA9" },
        { code: "4733", rgb: "#AEB3BD" },
        { code: "4734", rgb: "#CAD0D6" },
        { code: "4735", rgb: "#E4E9E9" },
        { code: "4740", rgb: "#5C545C" },
        { code: "4741", rgb: "#7C7B86" },
        { code: "4742", rgb: "#9F9FAA" },
        { code: "4743", rgb: "#B4B6BD" },
        { code: "4744", rgb: "#D2D4DA" },
        { code: "4745", rgb: "#E5E8E9" },
        { code: "4750", rgb: "#5D575A" },
        { code: "4751", rgb: "#7F7A7E" },
        { code: "4752", rgb: "#979294" },
        { code: "4753", rgb: "#B4AFAF" },
        { code: "4754", rgb: "#CDC9C8" },
        { code: "4755", rgb: "#E5E6E3" },
        { code: "4760", rgb: "#554445" },
        { code: "4761", rgb: "#796A6E" },
        { code: "4762", rgb: "#A09496" },
        { code: "4763", rgb: "#B4ABAD" },
        { code: "4764", rgb: "#CFCACB" },
        { code: "4765", rgb: "#E5E3E0" },
        { code: "4770", rgb: "#6F4643" },
        { code: "4771", rgb: "#916B6C" },
        { code: "4772", rgb: "#AC8584" },
        { code: "4773", rgb: "#C4A2A1" },
        { code: "4774", rgb: "#D9C3C2" },
        { code: "4775", rgb: "#F0E3DF" },
        { code: "4780", rgb: "#8C5047" },
        { code: "4781", rgb: "#A06D66" },
        { code: "4782", rgb: "#B2786E" },
        { code: "4783", rgb: "#C38D87" },
        { code: "4784", rgb: "#DEB3AA" },
        { code: "4785", rgb: "#F2DAD1" },
        { code: "4790", rgb: "#4B5662" },
        { code: "4791", rgb: "#707F90" },
        { code: "4792", rgb: "#92A0AE" },
        { code: "4793", rgb: "#AFBBC3" },
        { code: "4794", rgb: "#CCD6DA" },
        { code: "4795", rgb: "#E8F0F2" },
        { code: "4800", rgb: "#485E76" },
        { code: "4801", rgb: "#718EA9" },
        { code: "4802", rgb: "#96B1C6" },
        { code: "4803", rgb: "#AEC4D7" },
        { code: "4804", rgb: "#CCDCE7" },
        { code: "4805", rgb: "#E6F2F5" },
        { code: "4810", rgb: "#435158" },
        { code: "4811", rgb: "#63737B" },
        { code: "4812", rgb: "#85949A" },
        { code: "4813", rgb: "#A1B0B6" },
        { code: "4814", rgb: "#C1CCCF" },
        { code: "4815", rgb: "#E1E9E8" },
        { code: "4820", rgb: "#50585D" },
        { code: "4821", rgb: "#78828A" },
        { code: "4822", rgb: "#8B9599" },
        { code: "4823", rgb: "#AAB1B5" },
        { code: "4824", rgb: "#C9D0D0" },
        { code: "4825", rgb: "#E1E9E7" },
        { code: "4830", rgb: "#4A5C54" },
        { code: "4831", rgb: "#677C78" },
        { code: "4832", rgb: "#8DA39D" },
        { code: "4833", rgb: "#A6B7B1" },
        { code: "4834", rgb: "#C6D4CF" },
        { code: "4835", rgb: "#E0EBE4" },
        { code: "4840", rgb: "#465959" },
        { code: "4841", rgb: "#697F81" },
        { code: "4842", rgb: "#899D9E" },
        { code: "4843", rgb: "#A6B7B7" },
        { code: "4844", rgb: "#C2D1D1" },
        { code: "4845", rgb: "#E4EFEB" },
        { code: "4850", rgb: "#3C6E82" },
        { code: "4851", rgb: "#709FB5" },
        { code: "4852", rgb: "#9BC3D3" },
        { code: "4853", rgb: "#B3D3DE" },
        { code: "4854", rgb: "#D0EAF0" },
        { code: "4855", rgb: "#E8F7F6" },
        { code: "7701", rgb: "#95937B" },
        { code: "7921", rgb: "#815C51" },
        { code: "9081", rgb: "#856254" },
        { code: "9090", rgb: "#7F6457" },
        { code: "9157", rgb: "#A6887C" },
        { code: "9158", rgb: "#846961" },
        { code: "9204", rgb: "#A29176" },
        { code: "9259", rgb: "#B19465" },
        { code: "9292", rgb: "#C4AA88" },
        { code: "9382", rgb: "#C6B29A" },
        { code: "9384", rgb: "#C0BDB0" },
        { code: "9388", rgb: "#BFB7A9" },
        { code: "9390", rgb: "#C4B8A5" },
        { code: "9602", rgb: "#ADA283" },
        { code: "9626", rgb: "#CAB48E" },
        { code: "9628", rgb: "#C2AB90" },
        { code: "9763", rgb: "#A79F89" },
        { code: "9765", rgb: "#A6967A" },
    ],
    extended: [],
    accent: [],
    proposed: [],
    background: '#ffffff',
    imgs: []
}

export type KnaufPaletteSets = { [k in KnaufPalettes]: Palette };

export const Palettes: KnaufPaletteSets = {
    [KnaufPalettes.invalid]: null,
    [KnaufPalettes.MiejskiSzyk]: MiejskiSzyk,
    [KnaufPalettes.KlasycznaElegancja]: KlasycznaElegancja,
    [KnaufPalettes.SwiatoweInspiracje]: SwiatoweInspiracje,
    // [KnaufPalettes.TopDesign]: TopDesign,
    [KnaufPalettes.WZgodzieZNatura]: WZgodzieZNatura,
    [KnaufPalettes.WszystkieKolory]: WszystkieKolory,
}
